require('./style.scss')
class Pusher
  @$inject: ["$uibModal"]
  constructor: (@modal)->

  push: (options)->
    instance = @modal.open
      template: require("./index.pug")
      controller: PusherCtrl             
      controllerAs: '$ctrl'
      windowClass: 'modal-pusher'
      resolve: 
        options: ()->
          return options?={}

    return instance.result

class PusherCtrl
  constructor: ($uibModalInstance, options)->
    @instance = $uibModalInstance  
    @filter = {}
    @selected = null
    @path = null
  confirm: ()->
    res = 
      resource: @selected
      path: @path
    @instance.close(res)
  cancel: ()->
    @instance.dismiss "cancelled"
    

module.exports = Pusher


// WEBPACK FOOTER //
// ./src/component/device/pusher/index.coffee